export default __webpack_public_path__ + "static/media/burger-salad.10c1d74a.svg";